import { DEFAULT_FORM_STATE } from '../constants/defaultFormState';
import { IFormState } from '../types/calculator';
import { EObjectType, ERealEstateType } from '../types/calculator/enums';

const OBJECT_COST_MAX = 999_999_999;

/** Нормализует стоимость: 0/пустое → дефолт формы, сверх максимума → clamp. */
export const normalizeObjectCostInput = (value: number | undefined): number => {
  if (value == null || Number.isNaN(value) || value <= 0) {
    return DEFAULT_FORM_STATE.objectCost;
  }

  if (value > OBJECT_COST_MAX) {
    return OBJECT_COST_MAX;
  }

  return value;
};

/** Стоимость для расчёта ПВ: 0 и пустое значение заменяются на дефолт формы. */
export const getEffectiveObjectCost = (objectCost: number | undefined): number => {
  return normalizeObjectCostInput(objectCost);
};

export const calculateValueFromPercentage = (oneHundredPercent: number, percent: number): number => {
  return Math.ceil((oneHundredPercent / 100) * percent);
};

export const calculatePercentage = (total: number, value: number) => {
  return (Number(value) / Number(total)) * 100;
};

export const isNewBuilding = (state: IFormState) => state.realEstateType === ERealEstateType.NewBuilding;
export const isSecondary = (state: IFormState) => state.realEstateType === ERealEstateType.Secondary;
export const isHouseBuilding = (state: IFormState) => state.realEstateType === ERealEstateType.HouseBuilding;

export const isApartments = ({ objectType }: IFormState) => objectType === EObjectType.Apartments;

export const isFlatOrUnselected = ({ objectType }: IFormState) =>
  objectType === EObjectType.Flat || objectType === undefined;
